export const tabController = () => {
	setTimeout(() => {
		const panelBodies = document.querySelectorAll('.components-panel__body-title button');
		panelBodies.forEach(item => {
			item.addEventListener('click', clickEveryItem);
		});

		function clickEveryItem() {
			this.removeEventListener('click', clickEveryItem);
			panelBodies.forEach(item => {
				if (item.getAttribute('aria-expanded') === 'true' && !item.isEqualNode(this)) {
					item.click();
				}
			});
			setTimeout(() => {
				this.addEventListener('click', clickEveryItem);
			}, 500);
		}
	}, 500);
};
export const sumObjectsByKey = (...objs) => {
	return objs.reduce((a, b) => {
		for (let k in b) {
			if (Object.prototype.hasOwnProperty.call(b, k))
				a[k] = (a[k] || 0) + b[k];
		}
		return a;
	}, {});
}